import React from 'react';
import './styles.css';

const Wrapper = ({ ...props }) => {
  return (
    <div className='kt-messaging-left-side-container'>
      { props.children }
    </div>
  );
};

export default Wrapper;
